import axios from "axios";
const url_api=process.env.REACT_APP_API_URL;
const AcademicUnitService={
    getAllAcademicUnit: async()=>{
        try {
            const response=await axios.get(url_api+"/academicUnit")
            return response;
        } catch (error) {
            return error;
        }
    },
    getListAcademitUnitByCampus:async(centerId)=>{
        try {
            const response=await axios.get(url_api+"/academicUnit/listAUbyCampus/"+centerId)
            return response;
        } catch (error) {
            return error;
        }
    },
    createAcademicUnit: async(newAcademicUnit)=>{
        try {
            const response=await axios.post(url_api+"/academicUnit/createacademicunit",newAcademicUnit);
            return response;
        } catch (error) {
            return error;
        }
    },
    deleteAcademicUnit: async(academicUnitId)=>{
        try {
            const response=await axios.delete(url_api+"/academicUnit/deleteacademicunit/"+academicUnitId)
            return response
        } catch (error) {
            return error;
        }
    },
    updateAcademicUnit: async(academicUnitId,updateAcademicUnit)=>{
        try {
            const response=await axios.put(url_api+"/academicUnit/updateacademicunit/"+academicUnitId,updateAcademicUnit)
            return response
        } catch (error) {
            return error;
        }
    },
}
export default AcademicUnitService;